import { Link } from "react-router-dom";
import { eventInfo } from "../lib/api";

export const Footer = () => {
  return (
    <footer className="relative mt-24 bg-ink text-cream overflow-hidden" data-testid="main-footer">
      <div className="absolute inset-0 terrazzo-dots opacity-10 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-4xl font-black mb-2">Rach Fest</p>
          <p className="font-display italic text-gold mb-6">celebrating 40 years of great choices</p>
          <p className="text-sm text-cream/70 leading-relaxed max-w-xs">
            Celebrating 40 years of great choices. Villa Taina, Cabarete, May 13–16, 2027.
          </p>
        </div>

        <div>
          <p className="font-display text-sm tracking-[0.3em] uppercase text-gold mb-4">Quick Links</p>
          <ul className="space-y-2 text-sm text-cream/85">
            <li><Link to="/rsvp" className="hover:text-terracotta transition-colors">RSVP</Link></li>
            <li><Link to="/stay" className="hover:text-terracotta transition-colors">Book a Room</Link></li>
            <li><Link to="/event" className="hover:text-terracotta transition-colors">The Event</Link></li>
            <li><Link to="/travel" className="hover:text-terracotta transition-colors">Travel Info</Link></li>
            <li><Link to="/faq" className="hover:text-terracotta transition-colors">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-display text-sm tracking-[0.3em] uppercase text-gold mb-4">Questions?</p>
          <p className="text-sm text-cream/85 leading-relaxed">
            Text me or email <a href={`mailto:${eventInfo.contactEmail}`} className="underline hover:text-terracotta">{eventInfo.contactEmail}</a>.
          </p>
          <p className="mt-6 text-xs text-cream/50 tracking-widest uppercase">
            Built with love · Cabarete, DR
          </p>
        </div>
      </div>
      <div className="palm-divider" />
    </footer>
  );
};

export default Footer;
